module.exports = __webpack_public_path__ + "static/media/Item_Weapon_BizonPP19_C.6057d19b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_BizonPP19_C.png
// module id = 215
// module chunks = 0